'use strict';

import { appendElement, appendInputToContactForm, appendStyleSheet, isReferrerMatchOrigin } from './utils/site';
import { localize } from './utils/localize';
import { setupPrint } from './utils/print';
import { sendGoogleClickId } from './utils/googClickId';
import { activateTextOrCallLinks, bindLocationsDropdown, triggerVisitorEngagementPrompt } from './utils/engagement';
import configJson from "./config.json"

const config = () => {
  if(typeof document === "undefined") return "";

  const hostname = document?.location?.hostname || "";
  if(hostname === "") return "";

  const printPublicKey = configJson?.printPublicKey || "";
  const siteConfig = configJson?.sites?.find(conf => conf?.rootDomain === hostname) || "";
  return { printPublicKey, siteConfig };
}

const analytics = (function () {
  const { printPublicKey, siteConfig } = config();
  if(siteConfig === "" || typeof siteConfig === "undefined" || typeof siteConfig !== "object") {
    return;
  }

  // appendElement("script", "head", {
  //   "src": "//cdn.jsdelivr.net/npm/promise-polyfill@8/dist/polyfill.min.js",
  // })

  // make sure `WCEvent()` and `eventDataGlobal` exist on the window for legacy analytics backwards compatibility
  appendElement("script", "head", {
    "innerHTML": `window.WCEvent = () => null;
    window.eventDataGlobal = null;`
  })

  if((siteConfig?.fpsDomain || "") !== "") {
    appendElement("link", "head", {
      "rel": "preconnect",
      "href": "https://fpcdn.io"
    })

    appendElement("link", "head", {
      "rel": "preconnect",
      "href": "https://use1.fptls.com"
    })

    appendElement("link", "head", {
      "rel": "preconnect",
      "href": `https://${siteConfig.fpsDomain}`
    })
  }

  if(((siteConfig?.measurementTagId || "") === "") && ((siteConfig?.universalAnalyticsTagId || "") !== "")) {
    appendElement("script", "head", {
      "innerHTML": `
      (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
          (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
          m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
      })(window,document,'script','//www.google-analytics.com/analytics.js','ga');

      ga('create', '${siteConfig.universalAnalyticsTagId}', '${siteConfig.rootDomain}');
      ga('send', 'pageview');`
    })
  }

  if((siteConfig?.measurementTagId || "") !== "") {
    appendElement("script", "head", {
      "async": true,
      "src": `https://www.googletagmanager.com/gtag/js?id=${siteConfig.measurementTagId}`,
    })

    appendElement("script", "head", {
      "innerHTML": `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());

        gtag('config', '${siteConfig.measurementTagId}');`
    })
  }

  if((siteConfig?.adWordsTagId || "") !== "") {
    appendElement("script", "head", {
      "async": true,
      "src": `https://www.googletagmanager.com/gtag/js?id=${siteConfig.adWordsTagId}`,
    })

    appendElement("script", "head", {
      "innerHTML": `window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());

        gtag('config', '${siteConfig.adWordsTagId}', {'allow_enhanced_conversions':true});`
    })
  }

  if((siteConfig?.siteVerificationToken || "") !== "") {
    appendElement("meta", "head", {
      "name": "google-site-verification",
      "content": `${siteConfig.siteVerificationToken}`,
    })
  }

  if((siteConfig?.sidebarSelector || "") !== "") {
    appendStyleSheet(`@media screen and (max-width: 600px) {
    ${siteConfig?.sidebarSelector} {
        visibility: hidden;
        display: none;
    }
}`)
  }

  if(siteConfig?.activateTextOrCall === true) {
    activateTextOrCallLinks();
    bindLocationsDropdown();
  }

  if(typeof document === "undefined") {} else {
    document.addEventListener('DOMContentLoaded', async () => {
      let geo1, geo2 = {};
      const isSameOrigin = isReferrerMatchOrigin();
      if(!isSameOrigin) {
        const setupPrintResponse = await setupPrint(siteConfig.fpsDomain, printPublicKey);
        geo1 = typeof setupPrintResponse === "object" ? setupPrintResponse?.geo1 || {} : geo1;
        geo2 = typeof setupPrintResponse === "object" ? setupPrintResponse?.geo2 || {} : geo2;
      }
      localize({geo1, geo2});
      sendGoogleClickId();
      if(siteConfig?.triggerVisitorEngagement === true) {
        triggerVisitorEngagementPrompt();
      }
      appendInputToContactForm("WV_URL", `${window.location.href}`)
      // appendInputToContactForm("WV_GEO1", `${window.location.href}`)
    });
  }

  return void 0;
}());

export default analytics;
